
import { Card } from "@/components/ui/card";
import { ArrowDown } from "lucide-react";

const SecurityVisualization = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-forti-fi-background to-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          {/* Increased card background opacity, removed inner gradient */}
          <Card className="relative rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all bg-white/90 backdrop-blur-md border border-gray-200/50">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-8 relative z-10"> {/* Added z-10 to ensure content is above any potential pseudo-elements from Card */}
              <div className="space-y-4">
                <h3 className="text-2xl font-serif text-forti-fi-DEFAULT">Advanced Visualization</h3>
                <p className="text-forti-fi-charcoal">
                  Our security systems create detailed visualizations of your perimeter, allowing for real-time monitoring and threat assessment with unprecedented clarity.
                </p>
                <div className="flex items-center text-forti-fi-teal space-x-2">
                  <ArrowDown className="h-4 w-4 animate-bounce" />
                  <span className="text-sm font-medium">Explore capabilities below</span>
                </div>
              </div>
              <div className="relative rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all transform hover:scale-[1.02] duration-300">
                <img 
                  src="/images/perimeter 1.jpg" 
                  alt="Forti-Fi fiber optic security visualization" 
                  className="w-full h-auto"
                />
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default SecurityVisualization;
